module.exports = __webpack_public_path__ + "static/img/technology-1-SD-WAN-img-4.5a714da.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_svg/technology-1-SD-WAN-img-4.svg
// module id = slOe
// module chunks = 0